/* eslint-disable @typescript-eslint/no-explicit-any */

export const getTitleEditionRestrictiveCovenants = (edition: any) =>
	edition?.summary?.RegisterEntryIndicators?.[0]?.NonChargeRestrictionIndicator?.[0];

export const getTitleEditionTerm = (edition: any) => edition?.summary?.Lease?.[0]?.LeaseEntry?.[0]?.LeaseTerm?.[0];
